import React, { createContext } from 'react';

export type SnackbarContextType = {
  show: (val: string, severity?: 'success' | 'info' | 'warning' | 'error') => void;
}

export const SnackbarContext = createContext<SnackbarContextType | null>(null);
